var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMembers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.545c0-.755-.265-1.474-.738-1.943C7.539 8.885 6.285 8 4.5 8S1.461 8.885.738 9.602C.265 10.072 0 10.79 0 11.545V13h9v-1.455zM4.5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm7 0a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm3.764 2.602C14.544 8.885 13.294 8 11.514 8c-.559 0-1.014 0-2.014.5.642.9 1.516 1.795 1.516 3.045V13H16v-1.455c0-.755-.264-1.474-.736-1.943z",
    fill: "#797584"
  })));
}

export default SvgMembers;